"use strict";
/*
 * Created on 03 01 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NumberInRangeValidator_1 = require("../../../core/model/data-dictionary/validators/NumberInRangeValidator");

var utils_1 = require("../../../core/utils");

var AbstractRelease_1 = require("../AbstractRelease");

var ReleaseType_1 = require("../ReleaseType");

var ReleaseWorkflowType_1 = require("../ReleaseWorkflowType");

var SelloutItemFilter_1 = require("./SelloutItemFilter");

var SelloutReleasePart_1 = require("./SelloutReleasePart");

var SelloutReleaseSnapshot_1 = require("./SelloutReleaseSnapshot");

var SelloutReleaseType_1 = require("./SelloutReleaseType");
/**
 * Representation of release for sellout pricing process. Encapsulates top level data for release of new prices. Some of data
 * are used as default values for more specific data, for which the user can set custom values on item level
 * and override the default ones.
 *
 * In contrast with a regular release, sellout releases are bound to {@link InternalSite internal sites} and can contain inactive products.
 * Products determined for a sellout release are imported from an external system. The core data represents
 * {@link SelloutSupply sellout supply} entity, although there can be other types of sellout releases for which products are determined
 * in other way (e.g. uploaded from a file).
 *
 * FYI: the references below will be removed, they serve only for developers to easily search core documents for development period.
 *      – screen description:
 *          – https://docs.google.com/spreadsheets/d/1OmgMuBQ3zKnlE_QfEs9McAFjUyzjcWnxmZpno2Wh67I/edit#gid=928163833
 *      – sellout price calculation
 *          – https://docs.google.com/document/d/1jHwH0WPlUsa96yTW9AO3yFpivilSSWygujT2UO8MrYE/edit#heading=h.330sngasxjp7 (use this)
 *          – https://docs.google.com/document/d/1CChasRodhpyLv-vA3ChIzT7AmWZvawOEEhhNXzHaRWM/edit#heading=h.jm8504djpfls
 *          (deprecated)
 *          – https://docs.google.com/document/d/1jHwH0WPlUsa96yTW9AO3yFpivilSSWygujT2UO8MrYE/edit?ts=5c7d4ad2#heading=h.330sngasxjp7
 *          (deprecated)
 *      – wire frames (be aware that they are not up to date, use screen description document instead)
 *          – https://l7vnbd.axshare.com/#p=s17_-_new_release__sell-out_-_sm_&g=1
 *
 * @author JMe
 */


var SelloutRelease =
/*#__PURE__*/
function (_AbstractRelease_1$Ab) {
  _inherits(SelloutRelease, _AbstractRelease_1$Ab);

  /**
   * @param id internal id of entity
   * @param name name of release
   * @param description free description of release
   * @param releaseType type of release (regular, simulation, sellout)
   * @param created time of creation of release entity
   * @param createdBy user who created this release entity
   * @param lastModified time of last modification (last saved)
   * @param lastModifiedBy user who modified this release as last (last saved)
   * @param priceListTypeId price list type id from {@link PriceListSettings settings}
   * @param priceListType price list type from {@link PriceListSettings settings}
   * @param selloutReleaseType sellout release type derived from price list type
   * @param productCategoryIds automatically resolved categories based on selected products
   * @param itemFilter release items selection filter as defined by user
   * @param releaseParts parts of release with separate workflow (e.g. approval, submission, ...)
   * @param workflowType type of workflow
   * @param state current release state; it is synchronized from individual states of sellout release parts
   * @param endDate default price validity end date (until the products should be sold out), value is distributed to product level
   * @param calcWorkflowCaseId id of case of a workflow which processes initial calculation of optimal prices in the entire release.
   * @param exportWorkflowCaseId case ID of a workflow which processes a preparation for release's export.
   * Is null if there has not yet been any export or the last export has been abandoned.
   * @param exportProgressMonitorId ID of a progress monitor associated with this release's export (an evaluation
   * of repricing possibility constraints). If null then the there is currently no such running operation.
   * @param exported date and time of last prices export; null if not exported (yet)
   * @param priceValidityStartDate expected start date of new price validity
   * @param totalPriceChangeLimit limit of maximum number of items with changed prices in the release, it is limit per site!
   * @param minPriceChangeInPercent minimal price change that should be applied to current regular price
   * @param maxPriceChangeInPercent maximal price change that should be applied to current regular price (PROFACT-608)
   * @param minMarginChangeInPercent minimal change (reduction) of margin that should be applied to
   * TODO RBe: Why min change and not the max change if this is margin decrease? Is this negative number to minimize?
   * Fill in to description.
   * @param cmDeadline deadline for the release. Serves for urgencies between CM and SCM/SM, ...
   * @param favourite indicates whether release is favourite one
   * @param validationResult validation messages (alerts)
   * @param reopened true if the sellout release was re-opened after being released
   * @param realImpact contains real (not forecasted) values of some business relevant metrics for already valid releases.
   *        Filled only for impact report.
   * @param calcProgressMonitorId id of progress monitor for optimal prices calculation
   * @param repricingEstimationThreshold user set value during release reopening. Only release items with estimation greater than this
   * threshold can be repriced
   * @param itemCountProgressMonitorId (LOG-4976) ID of a progress monitor associated with computation of item counts that
   *        are identified for sellout within product categories. If null then there is currently no such running operation.
   * @param computingProcessId ID of application instance working with this release (performing price calculations)
   * @param reopenSnapshots List of states (configurations) of sellout releases taken before each reopen.
   */
  function SelloutRelease(id, name, description, releaseType, created, createdBy, lastModified, lastModifiedBy, priceListTypeId, priceListType, selloutReleaseType, productCategoryIds, itemFilter, // null in Urgent (or in old data)
  releaseParts, workflowType, state, // JMe/RBe validate this according to sellout workflow, may be this will differ
  endDate, // null in Urgent
  calcWorkflowCaseId, exportWorkflowCaseId, exportProgressMonitorId, exported, priceValidityStartDate, // null in Urgent
  totalPriceChangeLimit, // null in Urgent or in delists (LOG-5674)
  minPriceChangeInPercent, // null in Urgent
  maxPriceChangeInPercent, minMarginChangeInPercent, // null in Urgent
  cmDeadline, // null in Urgent
  favourite, validationResult, reopened, realImpact, calcProgressMonitorId, repricingEstimationThreshold, itemCountProgressMonitorId, computingProcessId, reopenSnapshots) {
    var _this;

    _classCallCheck(this, SelloutRelease);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutRelease).call(this, id, name, description, releaseType, created, createdBy, lastModified, lastModifiedBy, priceListTypeId, priceListType, productCategoryIds, releaseParts, workflowType, state, calcWorkflowCaseId, exportWorkflowCaseId, exportProgressMonitorId, priceValidityStartDate, totalPriceChangeLimit, exported, cmDeadline, favourite, validationResult, realImpact, calcProgressMonitorId, computingProcessId));
    _this.id = id;
    _this.name = name;
    _this.description = description;
    _this.releaseType = releaseType;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.lastModifiedBy = lastModifiedBy;
    _this.priceListTypeId = priceListTypeId;
    _this.priceListType = priceListType;
    _this.selloutReleaseType = selloutReleaseType;
    _this.productCategoryIds = productCategoryIds;
    _this.itemFilter = itemFilter;
    _this.releaseParts = releaseParts;
    _this.workflowType = workflowType;
    _this.state = state;
    _this.endDate = endDate;
    _this.calcWorkflowCaseId = calcWorkflowCaseId;
    _this.exportWorkflowCaseId = exportWorkflowCaseId;
    _this.exportProgressMonitorId = exportProgressMonitorId;
    _this.exported = exported;
    _this.priceValidityStartDate = priceValidityStartDate;
    _this.totalPriceChangeLimit = totalPriceChangeLimit;
    _this.minPriceChangeInPercent = minPriceChangeInPercent;
    _this.maxPriceChangeInPercent = maxPriceChangeInPercent;
    _this.minMarginChangeInPercent = minMarginChangeInPercent;
    _this.cmDeadline = cmDeadline;
    _this.favourite = favourite;
    _this.validationResult = validationResult;
    _this.reopened = reopened;
    _this.realImpact = realImpact;
    _this.calcProgressMonitorId = calcProgressMonitorId;
    _this.repricingEstimationThreshold = repricingEstimationThreshold;
    _this.itemCountProgressMonitorId = itemCountProgressMonitorId;
    _this.computingProcessId = computingProcessId;
    _this.reopenSnapshots = reopenSnapshots;
    return _this;
  }
  /**
   * Returns true if given release is sellout release.
   * Use this method rarely, only in meaningful cases.
   */


  _createClass(SelloutRelease, [{
    key: "withUpdatedReleaseParts",

    /**
     * Updates release parts using given function and returns updated release (that can be later stored in DB).
     * @param update
     */
    value: function withUpdatedReleaseParts(update) {
      return this.copy('releaseParts', this.releaseParts.map(function (releasePart) {
        return update(releasePart);
      }));
    }
    /**
     * Returns only approved release parts.
     */

  }, {
    key: "approvedReleaseParts",
    value: function approvedReleaseParts() {
      return this.releaseParts.filter(function (part) {
        return part.approved !== null;
      });
    }
    /**
     * Returns only readonly release parts.
     */

  }, {
    key: "readonlyReleaseParts",
    value: function readonlyReleaseParts() {
      return this.releaseParts.filter(function (part) {
        return part.readonly;
      });
    }
    /**
     * Gets remaining stock amount we want to sell out based on sellout release type.
     */

  }, {
    key: "getRemainingStockAmount",
    value: function getRemainingStockAmount(releaseItem) {
      return releaseItem.supplyData !== null ? releaseItem.supplyData.getStockAmount() : null;
    }
  }, {
    key: "isWithoutTotalPriceChangeLimit",
    value: function isWithoutTotalPriceChangeLimit() {
      return this.workflowType === ReleaseWorkflowType_1.ReleaseWorkflowType.SelloutUrgent || this.selloutReleaseType === SelloutReleaseType_1.SelloutReleaseType.ExitInOutDelist || this.selloutReleaseType === SelloutReleaseType_1.SelloutReleaseType.ExitRegularDelist;
    }
    /**
     * Returns priceValidityStartDate for specified reopen. 0 stands for initial release open. If provided number
     * is the same as total reopen count, current start date is returned. If it is bigger than total reopen count
     * null is returned.
     *
     * @param reopen order number of release reopen
     */

  }, {
    key: "priceValidityStartDateForReopen",
    value: function priceValidityStartDateForReopen(reopen) {
      return this.returnValueForReopen(reopen, 'priceValidityStartDate');
    }
    /**
     * Returns endDate for specified reopen. 0 stands for initial release open. If provided number
     * is the same as total reopen count, current end date is returned. If it is bigger than total reopen count
     * null is returned.
     *
     * @param reopen order number of release reopen
     */

  }, {
    key: "priceValidityEndDateForReopen",
    value: function priceValidityEndDateForReopen(reopen) {
      return this.returnValueForReopen(reopen, 'endDate');
    }
  }, {
    key: "returnValueForReopen",
    value: function returnValueForReopen(reopen, key) {
      if (reopen === this.reopenSnapshots.size) {
        return this[key];
      }

      var snapshot = this.reopenSnapshots.get(reopen);
      return snapshot ? snapshot[key] : null;
    }
    /**
     * Returns total count of release opening - initial open + reopen count.
     */

  }, {
    key: "totalOpenCount",
    value: function totalOpenCount() {
      return this.reopenSnapshots.size + 1;
    }
  }], [{
    key: "isSelloutRelease",
    value: function isSelloutRelease(release) {
      return release.releaseType === ReleaseType_1.ReleaseType.Sellout;
    }
  }, {
    key: "requireSelloutRelease",
    value: function requireSelloutRelease(release) {
      if (!SelloutRelease.isSelloutRelease(release)) {
        throw new Error("Not implemented for releaseId=".concat(release.id, ", releaseType=").concat(release.releaseType, " (requireSelloutRelease)."));
      }

      return release;
    }
    /**
     * <p>
     * Returns minimal price validity start date from release-level priceValidityStartDate (if defined) and from
     * final prices in given release items. If there is no minimum defined, actual date is returned instead.
     * </p>
     *
     * @param priceValidityStartDate Release price validity start.
     * @param releaseItems Tested release items.
     * @returns resolved minimum price validity start or current date
     */

  }, {
    key: "getMinPriceValidityStartDate",
    value: function getMinPriceValidityStartDate(priceValidityStartDate, releaseItems) {
      var minStartDate = priceValidityStartDate;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = releaseItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.prices.finalPrice !== null && minStartDate === null) {
            minStartDate = item.prices.finalPrice.validFrom;
          } else if (item.prices.finalPrice !== null && item.prices.finalPrice.validFrom.isBefore(minStartDate)) {
            minStartDate = item.prices.finalPrice.validFrom;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return minStartDate ? minStartDate : moment();
    }
    /**
     * Returns maximal price validity start date from release-level priceValidityStartDate (if defined) and from
     * final prices in given release items.
     * @param priceValidityStartDate
     * @param releaseItems
     */

  }, {
    key: "getMaxPriceValidityStartDate",
    value: function getMaxPriceValidityStartDate(priceValidityStartDate, releaseItems) {
      var minStartDate = priceValidityStartDate !== null ? priceValidityStartDate : utils_1.Utils.getFarFutureMoment();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = releaseItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          if (item.prices.finalPrice !== null && item.prices.finalPrice.validFrom.isBefore(minStartDate)) {
            minStartDate = item.prices.finalPrice.validFrom;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return minStartDate;
    }
  }]);

  return SelloutRelease;
}(AbstractRelease_1.AbstractRelease);

exports.SelloutRelease = SelloutRelease; // Relates to SelloutReleaseItem.evaluation.estimationInPercent. If the estimationInPercent is 100 or greater, the sales are going
// as expected. There is no need for repricing. It is relevant only for reopened releases.

SelloutRelease.DEFAULT_REPRICING_ESTIMATION_THRESHOLD = 100;

SelloutRelease.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutRelease.name);
  return Object.assign(Object.assign({}, AbstractRelease_1.AbstractRelease.schemaBase), {
    selloutReleaseType: builder.senum('selloutReleaseType', SelloutReleaseType_1.SelloutReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutReleaseType),
    itemFilter: builder.opt(builder.obj('itemFilter', SelloutItemFilter_1.SelloutItemFilter.schema, function (mat) {
      return new SelloutItemFilter_1.SelloutItemFilter(mat.zoneId, mat.siteIds, mat.weighted, mat.unitsPerSite, mat.stockValue, mat.selloutVolume, mat.futurePromoInWeeks, mat.daysToExpiration, mat.endDateFrom, mat.endDateTo, mat.productExternalIds, mat.returnable);
    })),
    releaseParts: builder.listOf(builder.obj('releaseParts', SelloutReleasePart_1.SelloutReleasePart.schema, function (mat) {
      return new SelloutReleasePart_1.SelloutReleasePart(mat.releaseId, mat.productCategoryId, mat.approved, mat.firstApproval, mat.approvedByUserId, mat.approvedByUserName, mat.cmDeadlineMissed, mat.workflowCaseId, mat.calcWorkflowCaseId, mat.calcProgressMonitorId, mat.validationResult, mat.readonly);
    })),
    endDate: builder.opt(builder.date('endDate', DateParser_1.DateParser.ISO_PATTERN)),
    minPriceChangeInPercent: builder.opt(builder.bigNum('minPriceChangeInPercent')),
    maxPriceChangeInPercent: builder.opt(builder.bigNum('maxPriceChangeInPercent')),
    minMarginChangeInPercent: builder.opt(builder.bigNum('minMarginChangeInPercent')),
    reopened: builder.bool('reopened'),
    repricingEstimationThreshold: builder.opt(builder.num('repricingEstimationThreshold', new NumberInRangeValidator_1.NumberInRangeValidator(0, 100))),
    itemCountProgressMonitorId: builder.opt(builder.str('itemCountProgressMonitorId')),
    reopenSnapshots: builder.listOf(builder.obj('reopenSnapshots', SelloutReleaseSnapshot_1.SelloutReleaseSnapshot.schema, SelloutReleaseSnapshot_1.SelloutReleaseSnapshot.fromDataDict))
  });
}();